/**
 * MenuSearchContainer component.
 */
import ScreenUtils from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Props for the menu search container.
 */
interface Props {
  collapse: boolean;
}

/**
 * Styled container for the menu search.
 */
const MenuSearchContainer = styled.div<Props>`
  cursor: ${({ collapse }) => (collapse ? 'default' : 'pointer')};
  left: ${20 * ScreenUtils.widthRatio}px;
  position: absolute;
  top: ${145 * ScreenUtils.widthRatio}px;
`;

export default withOpacity(MenuSearchContainer);
